export default __webpack_public_path__ + "static/media/altair.a40ae984.svg";